import { HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

type InfoTooltipProps = {
  text: string;
  /** Larger touch target on mobile */
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
};

/**
 * Inline info icon with tooltip — use for field hints, filter explanations, dense UI.
 */
export function InfoTooltip({ text, className, side = 'top' }: InfoTooltipProps) {
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            'inline-flex shrink-0 rounded-full text-muted outline-none ring-offset-2 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring',
            className
          )}
          aria-label="Mehr Infos"
        >
          <HelpCircle className="h-3.5 w-3.5" strokeWidth={2} />
        </button>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-left text-sm leading-relaxed">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
